import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import parse from 'html-react-parser';

import { clause } from '@api/axiosAPI';
import { Header } from '@components';
import { unescapeHtml } from '@lib/utils';

const ClauseTemplate = () => {
  const [clauseList, setClauseList] = useState([]);
  const { clseId } = useParams();
  const [searchParams] = useSearchParams();
  const query = searchParams.get('headerYn');

  // 약관 목록 조회
  const { data } = clause.getClauseList(['getClauseList'], { enabled: true }, { clseId: clseId });

  useEffect(() => {
    setClauseList(data);
  }, [data]);

  return (
    <>
      {clauseList &&
        clauseList?.map((e) => {
          if (e.clseId === clseId) {
            return (
              <div key={e.clseId}>
                {(_.isEmpty(query) || query === 'Y') && <Header title={e.clseTitl} />}
                {parse(unescapeHtml(e.clseCtt))}
                {/* <section className="sub_container bg-white">
                  <pre className="Padding-20 ws_pre">{parse(unescapeHtml(e.clseCtt))} </pre>
                </section> */}
              </div>
            );
          }
        })}
    </>
  );
};

export default ClauseTemplate;
